import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import "./GridWithCentralArea.css";

function GridWithCentralArea() {
  const [searchParams] = useSearchParams();
  const [loadedButtons, setLoadedButtons] = useState([]); // Pulsanti dinamici
  const [activeContentGrid, setActiveContentGrid] = useState(null); // Contenuto attivo
  const [isIdle, setIsIdle] = useState(false);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [carouselContent, setContent] = useState([]);
  const [savedContent, setSavedContent] = useState({}); // Salva contenuto precedente
  const [showQRCode, setShowQRCode] = useState(false); // Stato del QR code
  const [lastVisitedUrls, setLastVisitedUrls] = useState({});

  useEffect(() => {
    console.log("entrato gridWithCentralArea")
    const totemsParams = searchParams.get("totem_id");
    if (totemsParams === 0) {
      alert('Valore totem_id è vuoto');
      return;
    }

    // Simulazione API per ottenere pulsanti dinamici
    fetch("https://api.psicopatici.com/api/totems/" + totemsParams)
      .then((response) => response.json())
      .then((data) => {

        const defaultButtons = data?.slides || [];
        const sortedButtons = defaultButtons.sort((a, b) => a.element_id - b.element_id);

        // Completa gli spazi vuoti fino a 12
        const completeGrid = Array.from({ length: 12 }, (_, index) => {
          const button = sortedButtons.find((b) => b.element_id === index + 1);
          return button || { id: `placeholder-${index + 1}`, type: "placeholder" };
        });

        setLoadedButtons(completeGrid);
        // setActiveContentGrid(completeGrid.find((b) => b.type !== "placeholder") || null);
        // Imposta il pulsante 6 come predefinito (se esiste)
        const defaultButton = completeGrid.find((b) => b.element_id === 6);
        if (defaultButton) {
          console.log('activeContent', defaultButton);
          setActiveContentGrid(defaultButton);
        }
      })
      .catch((err) => console.error(err));

    // Simulazione API per ottenere pulsanti dinamici
    fetch("https://api.psicopatici.com/api/totems")
      .then((response) => response.json())
      .then((data) =>
        setContent([
          "https://cdn.psicopaticiservice.com/webp/wd228-leggins/foto-prodotto/wd-228-4.webp",
          "https://cdn.psicopaticiservice.com/webp/cappotto-wd217/foto-prodotto/wd217-4-2.webp",
          "https://crm.psicopatici.com/totemv1/images/C0683.mp3",
          "https://crm.psicopatici.com/totemv1/images/C0696.mp3",
        ])

      )
      .catch((err) => console.error(err));

    console.log("Loaded Buttons:", loadedButtons);

    let idleTimer;
    let homeTimer;

    const resetIdleTimer = () => {
      setIsIdle(false);
      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => setIsIdle(true), 600000);
      homeTimer = setTimeout( () => { })
    };

    // Eventi per monitorare l'attività
    window.addEventListener("mousemove", resetIdleTimer);
    window.addEventListener("keydown", resetIdleTimer);
    window.addEventListener("click", resetIdleTimer);

    resetIdleTimer();

    return () => {
      clearTimeout(idleTimer);
      window.removeEventListener("mousemove", resetIdleTimer);
      window.removeEventListener("keydown", resetIdleTimer);
      window.removeEventListener("click", resetIdleTimer);
    };


    // Aggiungi un listener per ricevere messaggi dall'iframe
    const handleMessage = (event) => {
      // Verifica che il messaggio provenga dall'URL atteso
      if (event.origin === "https://store.psicopatici.com") {
        const { lastVisited } = event.data;
        if (lastVisited && activeContentGrid?.element_id) {
          // Aggiorna l'URL per la categoria attiva
          console.log('lastvisited', lastVisited);
          // console.log('contenutoattivo', activeContentGrid);
          setLastVisitedUrls((prev) => ({
            ...prev,
            [activeContentGrid.element_id]: lastVisited,
          }));

        }
      }
    };

    // Ascolta i messaggi
    window.addEventListener("message", handleMessage);

    return () => {
      // Rimuovi il listener quando il componente viene smontato
      window.removeEventListener("message", handleMessage);
    };

  }, [activeContentGrid]);


  // const buttonClickHandler = (button) => {
  //   if (button.element_id === 8) {
  //     setShowQRCode(true); // Mostra il QR code
  //     return;
  //   }
  //   if (button.type === "url") {
  //     // Recupera l'ultima URL visitata per il nuovo pulsante
  //     const lastVisitedUrl = lastVisitedUrls[button.element_id] || button.content;

  //     if (activeContentGrid) {
  //       // Aggiorna la lista di pulsanti scambiando il contenuto e la posizione
  //       setLoadedButtons((prevButtons) =>
  //         prevButtons.map((b) => {
  //           if (b.element_id === button.element_id) {
  //             // Il pulsante cliccato prende il contenuto del pulsante attivo
  //             return { ...b, content: activeContentGrid.content, type: activeContentGrid.type, name: activeContentGrid.name };
  //           }
  //           if (b.element_id === activeContentGrid.element_id) {
  //             // Il pulsante attivo prende il contenuto del pulsante cliccato
  //             return { ...b, content: lastVisitedUrl, type: button.type, name: button.name };
  //           }
  //           return b;
  //         })
  //       );
  //     }

  //     // Aggiorna il contenuto attivo con il nuovo pulsante e l'ultima URL visitata
  //     setActiveContentGrid({ ...button, content: lastVisitedUrl });
  //   } else {

  //     setActiveContentGrid({ ...button, content: button.content });
  //   }

  // };


  const buttonClickHandler = (button) => {
    if (button.type === "placeholder") return;
    if (button.id === 8) {
      setShowQRCode(true);
      return;
    }
    setActiveContentGrid(button);
  };

  const closeQRCode = () => {
    setShowQRCode(false);
  };

  useEffect(() => {
    if (isIdle) {
      const interval = setInterval(() => {
        setCarouselIndex((prevIndex) => (prevIndex + 1) % carouselContent.length);
      }, 10000); // Cambia contenuto ogni 10 secondi
      return () => clearInterval(interval);
    }
  }, [isIdle, carouselContent.length]);


  if (isIdle) {
    // Mostra il carosello in modalità inattività
    const currentContent = carouselContent[carouselIndex];
    return (
      <div className="carousel-fullscreen">
        {/* {currentContent.endsWith(".mp4") ? (
          <video
            src={currentContent}
            autoPlay
            muted
            loop
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        ) : (
          <img
            src={currentContent}
            alt="Carousel Content"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        )} */}
        <video
          src="https://totem.psicopatici.com/Video_totem_Ilenia_ufficiale_4.mp4"
          autoPlay
          loop
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
        {/* <img
          src='https://api.psicopatici.com/public/media/3OXd0bmFnueZCGlV3b9I.webp'
          alt="Carousel Content"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        /> */}
      </div>
    );
  }
  return (
    <div className="grid-with-central-area">
      {showQRCode && activeContentGrid?.type === "url" && (
        <div className="qr-code-overlay" onClick={closeQRCode}>
          <QRCodeCanvas value={activeContentGrid.content} size={256} />
          <p>Scansiona per continuare la navigazione sul tuo smartphone</p>
        </div>
      )}
      {/* RIGA SUPERIORE */}
      <div className="grid-row top-row">
        {loadedButtons.slice(0, 4).map((button) => (
          <div key={button.element_id}
            className={`banner pointer-events ${button.type === "placeholder" ? "hide-placeholder" : ""}`}>
            {button.type === "image" ? (
              <img
                src={"https://api.psicopatici.com/public/" + button.content}
                alt={button.name}
                // onClick={() => buttonClickHandler(button)}
                style={{ cursor: "pointer", width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : button.type === "video" ? (
              <video
                src={"https://api.psicopatici.com/public/" + button.content}
                // onClick={() => buttonClickHandler(button)}
                style={{ cursor: "pointer", width: "100%", height: "100%", objectFit: "cover" }}
                autoPlay
                muted
                loop
              />
            ) : button.type === "qr" ? (
              <button
                // onClick={() => buttonClickHandler(button)}
                style={{
                  backgroundColor: `#000`,
                  backgroundSize: "cover",
                  width: "100%",
                  height: "100%",
                  border: "none",
                  cursor: "pointer",
                  display: "inline-block"
                }}
              >

                <QRCodeCanvas value={activeContentGrid.content} size={100} />
                <br></br>
                <p>Scansiona per continuare la navigazione sul tuo smartphone</p>

              </button>
            ) : button.type === "url" ? (
              <button
                onClick={() => buttonClickHandler(button)}
                style={{
                  backgroundImage: `url(https://api.psicopatici.com/public/${button.file})`,
                  backgroundSize: "cover",
                  width: "100%",
                  height: "100%",
                  border: "none",
                  cursor: "pointer",
                }}
                className="url"
              >
                <span>{button.name}</span>
              </button>

            ) : (
              // <div className="placeholder"></div>
              <></>
            )}
          </div>
        ))}
      </div>

      {/* SEZIONE CENTRALE CON COLONNE LATERALI */}
      <div className="grid-middle-row">
        <div className="side-column">
          {loadedButtons.slice(4, 6).map((button) => (
            <div key={button.element_id} className={`banner pointer-events ${button.type === "placeholder" ? "hide-placeholder" : ""}`}>
              {button.type === "image" ? (
                <img
                  src={button.content}
                  alt={button.name}
                  // onClick={() => buttonClickHandler(button)}
                  style={{ cursor: "pointer", width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : button.type === "video" ? (
                <video
                  src={button.content}
                  // onClick={() => buttonClickHandler(button)}
                  style={{ cursor: "pointer", width: "100%", height: "100%", objectFit: "cover" }}
                  autoPlay
                  muted
                  loop
                />
              ) : button.type === "qr" ? (
                <button
                  // onClick={() => buttonClickHandler(button)}
                  style={{
                    backgroundColor: `#000`,
                    backgroundSize: "cover",
                    width: "100%",
                    height: "100%",
                    border: "none",
                    cursor: "pointer",
                    display: "inline-block"
                  }}
                >

                  <QRCodeCanvas value={activeContentGrid.content} size={100} />
                  <br></br>
                  <p>Scansiona per continuare la navigazione sul tuo smartphone</p>

                </button>
              ) : button.type === "url" ? (
                <button
                  onClick={() => buttonClickHandler(button)}
                  style={{
                    backgroundImage: `url(https://api.psicopatici.com/public/${button.file})`,
                    backgroundSize: "cover",
                    width: "100%",
                    height: "100%",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  <span>{button.name}</span>
                </button>

              ) : (

                // <div className="placeholder"></div>
                <></>
              )}
            </div>
          ))}
        </div>

        {/* AREA CENTRALE */}
        <div className="central-area">
          {activeContentGrid ? (
            activeContentGrid.type === "image" ? (
              <img
                src={"https://api.psicopatici.com/public/" + activeContentGrid.content}
                alt={activeContentGrid.name}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : activeContentGrid.type === "video" ? (
              <video
                src={"https://api.psicopatici.com/public/" + activeContentGrid.content}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                autoPlay
                muted
                loop
              />
            ) : activeContentGrid.type === "url" ? (
              <iframe
                src={activeContentGrid.content}
                title="Central Content"
                style={{ width: "100%", height: "100%", border: "none" }}
              // onLoad={handleIframeNavigation}
              ></iframe>
            ) : null
          ) : (
            <iframe
              src={"https://store.psicopatici.com/product-categories/donna"}
              title="Content Area"
              style={{ width: "100%", height: "100%", border: "none" }}
            // onLoad={handleIframeNavigation}
            ></iframe>
          )}
        </div>

        <div className="side-column">
          {loadedButtons.slice(6, 8).map((button) => (
            <div
              key={button.element_id}
              className={`banner pointer-events ${button.type === "placeholder" ? "hide-placeholder" : ""}`}
            >
              {button.type === "image" ? (
                <img
                  src={"https://api.psicopatici.com/public/" + button.content}
                  alt={button.name}
                  // onClick={() => buttonClickHandler(button)}
                  style={{ cursor: "pointer", width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : button.type === "video" ? (
                <video
                  src={"https://api.psicopatici.com/public/" + button.content}
                  // onClick={() => buttonClickHandler(button)}
                  style={{ cursor: "pointer", width: "100%", height: "100%", objectFit: "cover" }}
                  autoPlay
                  muted
                  loop
                />
              ) : button.type === "qr" ? (
                <button
                  // onClick={() => buttonClickHandler(button)}
                  style={{
                    backgroundColor: `#000`,
                    backgroundSize: "cover",
                    width: "100%",
                    height: "100%",
                    border: "none",
                    cursor: "pointer",
                    display: "inline-block"
                  }}
                >

                  <QRCodeCanvas value={activeContentGrid.content} size={100} />
                  <br></br>
                  <p>Scansiona per continuare la navigazione sul tuo smartphone</p>

                </button>
              ) : button.type === "url" ? (
                <button
                  onClick={() => buttonClickHandler(button)}
                  style={{
                    backgroundImage: `url(https://api.psicopatici.com/public/${button.file})`,
                    backgroundSize: "cover",
                    width: "100%",
                    height: "100%",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  <span>{button.name}</span>
                </button>

              ) : (

                // <div className="placeholder"></div>
                <></>
              )}
            </div>
          ))}
        </div>
      </div>
      {/* RIGA INFERIORE */}
      <div className="grid-row bottom-row">
        {loadedButtons.slice(8, 12).map((button) => (
          <div
            key={button.element_id}
            className={`banner pointer-events ${button.type === "placeholder" ? "hide-placeholder" : ""}`}
          >
            {button.type === "image" ? (
              <img
                src={"https://api.psicopatici.com/public/" + button.content}
                alt={button.name}
                // onClick={() => buttonClickHandler(button)}
                style={{ cursor: "pointer", width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : button.type === "video" ? (
              <video
                src={"https://api.psicopatici.com/public/" + button.content}
                // onClick={() => buttonClickHandler(button)}
                style={{ cursor: "pointer", width: "100%", height: "100%", objectFit: "cover" }}
                autoPlay
                muted
                loop
              />
            ) : button.type === "qr" ? (
              <button
                // onClick={() => buttonClickHandler(button)}
                style={{
                  backgroundColor: `#000`,
                  backgroundSize: "cover",
                  width: "100%",
                  height: "100%",
                  border: "none",
                  cursor: "pointer",
                  display: "inline-block"
                }}
              >

                <QRCodeCanvas value={activeContentGrid.content} size={100} />
                <br></br>
                <p>Scansiona per continuare la navigazione sul tuo smartphone</p>

              </button>
            ) : button.type === "url" ? (
              <button
                onClick={() => buttonClickHandler(button)}
                style={{
                  backgroundImage: `url(https://api.psicopatici.com/public/${button.file})`,
                  backgroundSize: "cover",
                  width: "100%",
                  height: "100%",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <span>{button.name}</span>
              </button>
            ) : (
              // <div className="placeholder"></div>
              <></>
            )}
          </div>
        ))}
      </div>

    </div>
  );
}

export default GridWithCentralArea;
